import styles from './Footer.module.css';
import content from "../Pages/Data/Footer.json";
import CopyToClipboard from '../Pages/components/copyToClipboard';

//icons
import { FaPhone } from "react-icons/fa";
import { IoMdMail } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";

//logoer
import lmLogo from "../Pages/images/LM_A_hvid_rgb.png"
import lmHFLogo from "../Pages/images/LM_D_HillerodFrimenighed_hvid_rgb.png"

export default  function Footer(){



    return(
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.box1}>
                    <img src={lmHFLogo} alt="Logo HF"/>
                    <div className={styles.info}>
                        <FaLocationDot className={styles.icon}></FaLocationDot>
                        <CopyToClipboard text={content.adresse}/>
                    </div>
                    <div className={styles.info}>
                        <IoMdMail className={styles.icon}></IoMdMail>
                        <CopyToClipboard text={content.mail}/>
                    </div>

                    <div className={styles.info}>
                        <FaPhone className={styles.icon}></FaPhone>
                        <CopyToClipboard text={content.telefon}/>
                    </div>
                </div>
                <div className={styles.box2}>
                    <h3>En del af:</h3>
                    <a href='https://dlm.dk/'>
                        <img src={lmLogo} alt="Logo" />
                    </a>
                </div>
            </div>
        </footer>
    )
}